module.exports = __webpack_public_path__ + "img/touxiang.0ffbb262.0ffbb262.jpg";